package one.healthium.login.navigation.magic_link

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.lifecycle.viewmodel.compose.LocalViewModelStoreOwner
import one.healthium.login.ui.magic_link.MagicLinkScreen

@Composable
fun MagicLinkContent(component: MagicLinkComponent) {
    CompositionLocalProvider(LocalViewModelStoreOwner provides component) {
        MagicLinkScreen(component.email, component)
    }
}